import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    'About': [
      { title: 'About Us', path: '/about' },
      { title: 'Contact', path: '/contact' },
      { title: 'Privacy Policy', path: '/privacy' },
      { title: 'Terms of Service', path: '/terms' },
    ],
    'Resources': [
      { title: 'Documentation', path: '/docs' },
      { title: 'API Reference', path: '/api' },
      { title: 'Support', path: '/support' },
      { title: 'FAQ', path: '/faq' },
    ],
    'Community': [
      { title: 'GitHub', path: 'https://github.com' },
      { title: 'Twitter', path: 'https://twitter.com' },
      { title: 'Discord', path: 'https://discord.com' },
      { title: 'LinkedIn', path: 'https://linkedin.com' },
    ],
  };

  return (
    <footer className="bg-primary-black text-primary-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-lg font-semibold mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.title}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-secondary-blue transition-colors"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} AI News. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 